import Hero from "@/components/Hero";
import SEO from "@/components/SEO";
import ValueProposition from "@/components/ValueProposition";
import HowItWorks from "@/components/HowItWorks";
import DiscordCommunity from "@/components/DiscordCommunity";
import CTASection from "@/components/CTASection";
import FAQ from "@/components/FAQ";

const Home = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <SEO 
        title="Oraculus:X - Elite Crypto Trading Signals Platform | AI-Powered Cryptocurrency Predictions"
        description="Access premium crypto trading signals unified in one platform. AI-powered Bitcoin & altcoin signals with 24/7 support. Start your free trial today."
      />
      <div className="fixed inset-0 bg-gradient-mesh animate-mesh-move opacity-40" />
      <div className="fixed inset-0 bg-gradient-opal-radial animate-gradient-shift" style={{ backgroundSize: '200% 200%' }} />
      
      <main className="relative z-10">
        <Hero />
        <ValueProposition />
        <HowItWorks />
        <DiscordCommunity />
        <CTASection />
        <FAQ />
      </main>
    </div>
  );
};

export default Home;
